(() => {
  if (window.rbPillowCartSplit) return;
  const BUNDLE_PRODUCT = 16612311761245;
  const PILLOW_VARIANT = 65528456315229;
  const LEGGINGS_BY_BUNDLE_VARIANT = {
    66123922866525: 65594207109469,
    66123922899293: 65594207142237,
    66123922932061: 65594207175005,
    66123922964829: 65594207207773,
    66123922997597: 65594207240541
  };
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  const request = async (path, body) => {
    const response = await fetch(root + path, body ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    } : { headers: { Accept: 'application/json' } });
    const result = await response.json();
    if (!response.ok || result.errors) throw new Error(result.description || result.message || 'Cart update failed.');
    return result;
  };
  const showError = (container, message) => {
    const status = container.querySelector('.rbpo-cart-components__feedback');
    if (!status) return;
    status.textContent = message;
    status.hidden = false;
  };
  const split = async (button, container) => {
    const cart = await request('cart.js');
    const parent = cart.items.find(item => item.key === container.dataset.rbpoCartKey && item.product_id === BUNDLE_PRODUCT);
    if (!parent) throw new Error('The set has changed. Refresh your cart and try again.');
    const keep = button.dataset.rbpoRemove === 'leggings' ? 'pillow' : 'leggings';
    const keptVariant = keep === 'pillow'
      ? Number(parent.properties?._rb_pillow_variant_id || container.dataset.rbpoCartPillow || PILLOW_VARIANT)
      : Number(parent.properties?._rb_leggings_variant_id || container.dataset.rbpoCartLeggings || LEGGINGS_BY_BUNDLE_VARIANT[parent.variant_id]);
    if (!keptVariant) throw new Error('This size could not be matched to the individual product.');
    const added = await request('cart/add.js', {
      items: [{ id: keptVariant, quantity: 1, properties: { _rb_pillow_split_from_set: parent.key } }]
    });
    const addedLine = Array.isArray(added.items) ? added.items[0] : added;
    let updated;
    try {
      updated = await request('cart/change.js', {
        id: parent.key,
        quantity: parent.quantity - 1,
        sections: ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'],
        sections_url: window.location.pathname
      });
    } catch (error) {
      if (addedLine.key) {
        try { await request('cart/change.js', { id: addedLine.key, quantity: 0 }); } catch (_) {}
      }
      throw error;
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.renderContents && updated.sections?.['cart-drawer'] && !window.location.pathname.endsWith('/cart')) {
      try {
        drawer.renderContents(updated);
        return;
      } catch (_) {}
    }
    window.location.reload();
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-rbpo-remove]');
    if (!button || busy) return;
    const container = button.closest('[data-rbpo-cart-key]');
    if (!container) return;
    event.preventDefault();
    busy = true;
    const buttons = container.querySelectorAll('[data-rbpo-remove]');
    buttons.forEach(item => { item.disabled = true; });
    try {
      await split(button, container);
      busy = false;
    } catch (error) {
      showError(container, error.message || 'We could not update the set. Please try again.');
      buttons.forEach(item => { item.disabled = false; });
      busy = false;
    }
  });
  window.rbPillowCartSplit = true;
})();
